import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description EyeOff icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { EyeOff } from '@sravni/design-system-icons'
 *
 * <EyeOff />
 * ```
 */
var EyeOff = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "EyeOff", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.514 11.514a2.143 2.143 0 1 1-3.028-3.028l3.028 3.028Zm2.729 2.729A7.193 7.193 0 0 1 10 15.714C5 15.714 2.143 10 2.143 10a13.179 13.179 0 0 1 3.614-4.243l8.486 8.486ZM8.5 4.457a6.515 6.515 0 0 1 1.5-.171c5 0 7.857 5.714 7.857 5.714-.433.811-.95 1.575-1.543 2.279L8.5 4.457ZM2.143 2.143l15.714 15.714", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { EyeOff };
//# sourceMappingURL=EyeOff.js.map
